import { z } from 'zod'

// Every field is optional: this step is pure business qualification, not a
// gate. The merchant can fill what they want or skip entirely (see the wizard's
// "Skip for now" affordance). The backend accepts empty strings/arrays.
export const stepAboutBusinessSchema = z.object({
	siteLive: z.boolean(),
	monthlyVolume: z.string(),
	needsProcessing: z.boolean(),
	currentProcessors: z.array(z.string()),
	platforms: z.array(z.string()),
	websiteUrl: z.string(),
})

export type StepAboutBusinessValues = z.infer<typeof stepAboutBusinessSchema>
